export default __webpack_public_path__ + "static/media/EagleViewLogoWithTextStacked.a49b0d87.svg";